<script>
  import { AppStore } from '../stores/AppStore'
  import PodcastCard from './PodcastCard.svelte'
</script>

<div class="w-full flex flex-col">
  <span class="font-bold text-blue-700">Latest Podcasts</span>
  {#if $AppStore.podcasts}
    <div class="w-full h-full flex flex-col sm:flex-row mt-2 sm:h-64">
      <div class="w-full sm:w-1/3 h-full sm:mr-2">
        <PodcastCard 
          podcastID={0} 
        />
      </div>
      <div class="w-full sm:w-1/3 h-full sm:mx-2 mt-1 sm:mt-0">
        <PodcastCard 
          podcastID={1} 
        />
      </div>
      <div class="w-full sm:w-1/3 h-full sm:ml-2 mt-1 sm:mt-0">
        <PodcastCard 
          podcastID={2} 
        />
      </div>
      <div class="w-full sm:w-1/3 h-full sm:ml-2 mt-1 sm:mt-0 hidden md:flex" />
      <div class="w-full sm:w-1/3 h-full sm:ml-2 mt-1 sm:mt-0 hidden xl:flex" />
    </div>
  {/if}
</div>